import { themes } from '../../bot/dist/bot.esm.js'

const d = new Date().toJSON()

export const theme = themes.find(t => t.background && t.startTime <= d && t.endTime >= d) || {
  background: '#005ba9 no-repeat bottom center',
  color: 'white',
  backgroundImage: '/assets/img/bg-rainbow.svg',
  avatar: '/assets/img/mascotte-cadeau.svg'
}
